import { createContext } from "react";
import { noop } from "@common/helpers/function";
import { Transaction } from "@common/types/transaction";
import { UpdateTransactionDto } from "@common/dto/transactions/update-transaction.dto";
import { EagerLoaded } from "@common/types/base/orm";
import { TransactionOrigin } from "@common/helpers/transactions";
import { AccrualMatchDisplay } from "@common/schemas/domains/accrualReview/accrual-review.schema";
import { TransactionFieldReviewDto } from "@common/schemas/transactionFieldReview.schema";

interface Context {
    transaction?: EagerLoaded<
        Transaction,
        "transactionMatches" | "pairedTransfer" | "category"
    > & {
        accrualMatches?: AccrualMatchDisplay[];
        fieldReviews?: TransactionFieldReviewDto[];
    };
    isDownloadingReceipt?: boolean;
    onDownloadReceipt(): void;
    onRemoveReceipt(): void;
    uploadingReceipt?: boolean;
    onAddReceipt(file: File): Promise<void>;
    onUpdate(
        payload: UpdateTransactionDto,
        displayedChangedEntityName?: string,
    ): Promise<void>;
    setTransaction(transaction: Transaction): void;
    receiptRequired: boolean;
    memoRequired: boolean;
    origins: TransactionOrigin[];
}

export const TransactionDetailsContext = createContext<Context>({
    onDownloadReceipt: noop,
    onRemoveReceipt: noop,
    onAddReceipt: () => Promise.resolve(),
    onUpdate: () => Promise.resolve(),
    setTransaction: noop,
    receiptRequired: false,
    memoRequired: false,
    origins: [],
});
